import { DeliveryT } from '../models/cart'

type ProductWithPrice = {
  price: number
  takeAwayPrice?: number
}

/**
 * Gets the appropriate price based on delivery type
 * If delivery type is TAKEAWAY and takeAwayPrice exists, return takeAwayPrice
 * Otherwise return the regular price
 */
export function getPrice(product: ProductWithPrice, deliveryType: DeliveryT): number {
  if (deliveryType === 'TAKEAWAY' && product.takeAwayPrice !== undefined && product.takeAwayPrice != null) {
    return product.takeAwayPrice
  }
  return product.price
}

export function getFormattedPrice(value: number) {
  if(value % 1 !== 0) {
    return `${value.toFixed(2)} kr`
  }
  return `${value} kr`
}

/**
 * Gets the formatted price based on delivery type (EATIN or TAKEAWAY)
 */
export function getFormattedPriceByDeliveryType(
  product: ProductWithPrice, 
  deliveryType: DeliveryT
): string {
  return getFormattedPrice(getPrice(product, deliveryType))
}